import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import Label from './Label';

export function getCrossDaySchedule(job) {
  if (job?.cross_day_schedule) return job.cross_day_schedule;
  if (!job?.customize) return null;
  try {
    return JSON.parse(job.customize)?.cross_day_schedule || null;
  } catch {
    return null;
  }
}

export function isCrossDayOverflow(job) {
  return getCrossDaySchedule(job)?.role === 'overflow';
}

export function isCrossDayMain(job) {
  return getCrossDaySchedule(job)?.role === 'main';
}

function getScheduleLabel(schedule) {
  if (schedule?.role === 'main') {
    return {text: '主', color: theme => theme.vars.palette.business.scheduleMain};
  }
  if (schedule?.role === 'overflow') {
    return schedule.overflow_kind === 'same_day'
      ? {text: '今溢', color: theme => theme.vars.palette.business.scheduleOverflowSameDay}
      : {text: '明溢', color: theme => theme.vars.palette.business.scheduleOverflowNextDay};
  }
  return null;
}

const JobNameWithScheduleLabel = ({job, name, compact}) => {
  const schedule = getCrossDaySchedule(job);
  const role = getScheduleLabel(schedule);
  const displayName = name ?? job?.name;

  if (compact) {
    return (
      <Box component="span" sx={{display: 'block', position: 'relative', width: '100%', maxWidth: '100%', minWidth: 0, overflow: 'hidden', lineHeight: 1.25}}>
        <Box
          component="span"
          sx={{
            display: 'block',
            minWidth: 0,
            overflow: 'hidden',
            pr: role ? (role.text.length > 1 ? '32px' : '22px') : 0,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {displayName}
        </Box>
        {role && (
          <Label
            component="span"
            variant="outlined"
            color={role.color}
            styles={{
              height: 18,
              minWidth: 0,
              px: 0.5,
              py: 0,
              lineHeight: '9px',
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            {role.text}
          </Label>
        )}
      </Box>
    );
  }

  return (
    <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', columnGap: 0.5, rowGap: 0.25, minWidth: 0}}>
      <Box component="span" sx={{minWidth: 0, whiteSpace: 'normal'}}>
        {displayName}
      </Box>
      {role && (
        <Label
          component="span"
          variant="outlined"
          color={role.color}
          styles={{height: 18, minWidth: 0, px: 0.5, py: 0, lineHeight: '9px', flexShrink: 0}}
        >
          {role.text}
        </Label>
      )}
    </Box>
  );
};

JobNameWithScheduleLabel.propTypes = {
  job: PropTypes.object,
  name: PropTypes.node,
  compact: PropTypes.bool,
};

JobNameWithScheduleLabel.defaultProps = {
  compact: false,
};

export default JobNameWithScheduleLabel;
